
import HtTabs from "../../components/HtTabs";
import MonthView from "./MonthView";
import NewContacts from "./NewContacts";
import MyContacts from "./MyContacts";
import Tests from "./Tests";
import SearchContacts from "./SearchContacts";
import FollowUp from "./FollowUp";
import AllLeads from "./AllLeads";


export default function Marketing(props) {

  const labels = ["New", "Monthly", "My contacts", "Check ins","Follow up", "Search","All leads"]
  const components = [<NewContacts />, <MonthView />, <MyContacts />, <Tests />,<FollowUp />, <SearchContacts />,<AllLeads />]

  return (
    <div>
      <HtTabs
        labels={labels}
        components={components}
       /*  nextToTabs={<BonusLevel />} */
     
      />
    </div>
  );
}